import { useEffect } from "react";
import CreateMap from "../components/createmap/CreateMap";
import { Helmet } from "react-helmet-async";

/**
 * @author sukim91
 * @date 2022-09-28 15:18:22
 * @remark 지도만들기 스크린
 * @param props None
 * @returns <CreateMap>
 */
function CreateMapScreen() {
    // useEffect(() => {
    //     document.getElementById("create_map")!.scrollIntoView({ behavior: "smooth" });
    // }, []);

    return (
        <>
            <Helmet>
                <title>지도만들기 - 모두의지도</title>
                <meta property="og:type" content="website" />
                <meta name="title" property="og:title" content="지도만들기 - 모두의지도" />
                <meta
                    name="description"
                    property="og:description"
                    content="간편하게 나만의 지도를 만들 수 있는 모두의지도! 다양한 마커와 정보를 추가해 나만의 지도를 완성해보세요."
                />
                <meta name="imgage" property="og:image" content="https://modoomap.com/createMap.jpg" />
                <meta name="url" property="og:url" content="https://modoomap.com/create" />
            </Helmet>
            <CreateMap />
        </>
    );
}

export default CreateMapScreen;
